import { render, staticRenderFns } from "./LinkReply.vue?vue&type=template&id=537c321d&"
import script from "./LinkReply.vue?vue&type=script&lang=js&"
export * from "./LinkReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports